import { Box, Image, Text } from '@mantine/core'

import CoinItem from '@/app/[locale]/price/[slug]/_components/More/CoinItem'
import useGlobalStore from '@/stores/global'
import { GlobalCoin } from '@/types/coin'
import { CryptoBasket, MoreCardType } from '@/types/invest'
import { formatPercentageColor } from '@/utils/number/format'

import styles from './styles.module.css'

type BasketCardProps = CryptoBasket & {
  type: MoreCardType
  priceChange: CryptoBasket['price_change']
}

export default function BasketCard({ icon_url, title, coins, priceChange }: BasketCardProps) {
  const COIN_CARD_NUMBER = 2
  const allCoins = useGlobalStore(state => state.allCoins)
  const exitCoins = coins.reduce((acc: GlobalCoin[], coin) => {
    const coinInfo = allCoins.find(globalCoin => globalCoin.slug === coin.name.toLowerCase())
    if (coinInfo) {
      acc.push(coinInfo)
    }
    return acc
  }, [])
  const filteredCoins = exitCoins?.slice(0, COIN_CARD_NUMBER)
  const changeColor = formatPercentageColor(Number(priceChange?.percentage || 0))
  const symbol = Number(priceChange?.percentage || 0) > 0 ? '+' : ''

  return (
    <Box
      className={styles.basketCard}
      onClick={() => {
        window.open('https://web.crypto.com/signup', '_blank')
      }}
    >
      {/* Image */}
      {icon_url && (
        <Box className={styles.basketImageContainer}>
          <Image src={icon_url} alt={title} className={styles.basketImage} />
          <Box className={styles.shadow} />
          <Text variant="heading3" className={styles.titleOverlay} truncate>
            {title}
          </Text>
        </Box>
      )}
      <Text
        pl={16}
        variant="subtitle"
        c={changeColor}
      >{`${symbol}${priceChange?.percentage || 0}%`}</Text>

      {/* Content */}
      <Box className={styles.contentContainer}>
        {filteredCoins?.map(coin => <CoinItem key={coin.id} {...coin} />)}
      </Box>
    </Box>
  )
}
